import { ApiError } from "@/modules/shared/utils/ApiError";

import { API_ERROR_TYPES, ApiErrorType } from "../consts/Events";

/**
 * Maps a thrown error from a booking or reschedule mutation to an
 * `error_type` analytics tag for the *_FAILED event.
 *
 * - 429 ApiError → rate limited (Bifrost or Glepnir throttled the request)
 * - other 4xx ApiError → validation (e.g. invalid coach, conflict)
 * - 5xx ApiError → server (Bifrost or downstream service failure)
 * - anything else → network (fetch threw before reaching Bifrost)
 */
export const getApiErrorType = (err: unknown): ApiErrorType => {
  if (!(err instanceof ApiError)) {
    return API_ERROR_TYPES.NETWORK;
  }
  if (err.status === 429) {
    return API_ERROR_TYPES.RATE_LIMITED;
  }
  if (err.status < 500) {
    return API_ERROR_TYPES.VALIDATION;
  }
  return API_ERROR_TYPES.SERVER;
};
